import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../main/main.styles';
import { mixinScreen } from '../../styles';

export const MarketDepthStyles = css`
  ${MainStyles}
  :host {
    ${mixinScreen('flex')}

    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .market-depth {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
  }

  .side-card {
    width: 375px;
    height: 100%;
  }

  .grid-card {
    height: 100%;
    flex: 1 auto;
    width: 100%;
  }

  .no-padding-card {
    padding: 0;
  }

  .market-depth-button-style {
    margin-left: 5px;
    height: 30px;
  }

  cancel-modal,
  vppa-modal,
  rfq-modal {
    display: contents;
  }
`;
